package org.example.project.model

enum class GameState {
    AUTH,
    HOME,
    MATCHMAKING,
    SHIP_PLACEMENT,
    COUNTDOWN,
    BATTLE,
    RESULT,
    LEADERBOARD
}